<template>
    <div class="card card-block hidden-sm-down card-category" v-if="isActive()">
        <h3>{{ getName() }}</h3>
<!--        <p>Nombre de produits : {{ getNbProducts()}}</p>-->
        <p>
            <label for="nbDisplayProduct">Nombre de produits affichés : </label>
            <select
                    name="nbDisplayProduct"
                    id="nbDisplayProduct"
                    v-model="nbProductsDiplay">

                <option disabled value="">Choisissez</option>
                <option v-for="option in options"
                        :value="option">
                    {{option}}
                </option>
            </select>
        </p>
        <Filters v-if="getFeatures() || getAttributesGroup()"
        ></Filters>

    </div>
</template>


<script>
    import Product from './Product';
    import Filters from './Filters';
    import {mapGetters, mapActions} from 'vuex'
    import * as types from '../store/types';

    export default {
        name: 'Category',
        components: {
            Product,
            Filters,
        },
        data() {
            return {
                options: [10, 20, 50],
            }
        },
        props: {
            category: {}
        },
        methods: {
            displayProduct(index) {
                return this.getNbProductsDiplay() === 0 || index < this.getNbProductsDiplay();
            },
            getNbProducts() {
                const {nb_products_recursive} = this.getCategory();

                return nb_products_recursive;
            },
            isActive() {
                return parseInt(this.category.active);
            },
            getName() {
                return this.category.name;
            },
            getDescription() {
                return this.category.description;
            },
            ...mapGetters({
                getAttributesGroup: types.GET_ATTRIBUTES_GROUP,
                getFeatures: types.GET_FEATURES,
                getNbProductsDiplay: types.GET_NB_PRODUCTS_DISPLAY,
                getCategory: types.GET_CATEGORY,
                getProducts: types.GET_PRODUCTS_RESULT,
            }),
            ...mapActions({
                updateNbProductsDisplay: types.UPDATE_NB_PRODUCTS_DISPLAY
            })
        },
        computed: {
            nbProductsDiplay: {
                get() {
                    return this.getNbProductsDiplay();
                },
                set(value) {
                    this.updateNbProductsDisplay(value)
                }
            }
        }
    }
</script>


<style scoped>

    .card-category {
        margin: 10px;
    }

</style>


// WEBPACK FOOTER //
// src/components/Category.vue